module.exports = {"name":"admin_assist","parameters":[{"name":"show_chatbot","value":["coursera"]}]}